import { Button, PageHeader } from 'components';
import { Form, Row, Col } from 'antd';
import styles from './style.module.scss';
import { CheckOutlined, EyeOutlined } from '@ant-design/icons';
import InfoSection from './formSections/info';
import { useTranslation } from 'react-i18next';
import NotificationFormForEdit from '../../../../../components/modules/notificationFormForEdit';
import useVacancies from '../useVacancies';

const New = ({ isNew }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const { handleApprove, singleItem, updateInProcess } = useVacancies(
    false,
    !isNew,
  );
  const onFinish = (values) => {
    console.log('Success:s', values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const onClickSave = () => {
    form.submit();
  };

  const title = '';

  return (
    <div>
      <PageHeader title={title}>
        <Row gutter={16}>
          <Col>
            <Button
              onClick={onClickSave}
              width={'150px'}
              big
              icon={<CheckOutlined />}
            >
              {t('Invia')}
            </Button>
          </Col>
        </Row>
      </PageHeader>
      <div className={styles.content}>
        <Form
          form={form}
          name='basic'
          wrapperCol={{
            span: 24,
          }}
          initialValues={
            {
              // remember: true,
            }
          }
          layout={'vertical'}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete='off'
        >
          <InfoSection />
        </Form>
      </div>
    </div>
  );
};

export default New;
